var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_vm._t("lt"),_c('div',{staticClass:"wt-row__content"},[_vm._t("default")],2),_vm._t("rt"),(_vm.arrow)?_c('wt-box',{staticClass:"wt-row__arrow"},[_vm._t("arrow",function(){return [_c('img',{staticClass:"wt-icon--fit",attrs:{"src":require("../../../assets/svg/arrow-right.svg")}})]})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }